export default function Hero() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative w-full min-h-[580px] md:min-h-[620px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20abstract%20stage%20with%20crimson%20and%20gold%20lighting%2C%20theatrical%20spotlight%20effect%2C%20mysterious%20atmosphere%20with%20smoke%20texture%2C%20entertainment%20industry%20aesthetic%2C%20editorial%20photography%20style%20with%20deep%20shadows%20and%20warm%20accents%2C%20cinematic%20composition&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="每日大赛黑料主视觉"
          className="w-full h-full object-cover"
          onError={(e) => {
            (e.target as HTMLElement).parentElement!.style.display = 'none';
          }}
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/65"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-xs md:text-sm font-medium tracking-wide mb-5 whitespace-nowrap">
              每日更新 · 全网首发
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
              每日大赛黑料
              <br className="hidden sm:block" />
              <span className="text-primary-300">全网最全大赛吃瓜第一站</span>
            </h1>

            <p className="text-base md:text-lg text-background-200/90 leading-relaxed max-w-xl mx-auto lg:mx-0 mt-5 mb-6">
              聚焦选秀、综艺、电竞、网红各大竞技赛事黑料内幕。从选手翻车到导师争议，从后台偷拍到独家爆料，每日大赛黑料为您汇集最新最热的大赛吃瓜内容。吃瓜群众聚集地，黑料吃瓜群每日更新，满足你对大赛八卦的一切好奇心。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-7">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">7×24h</div>
                <div className="text-xs text-background-300 mt-1">全天候更新</div>
              </div>
              <div className="w-px h-10 bg-background-300/30 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">10万+</div>
                <div className="text-xs text-background-300 mt-1">吃瓜群众在线</div>
              </div>
              <div className="w-px h-10 bg-background-300/30 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">100%</div>
                <div className="text-xs text-background-300 mt-1">一手爆料来源</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#updates"
                onClick={(e) => handleScroll(e, '#updates')}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg text-sm transition-all cursor-pointer whitespace-nowrap text-center"
              >
                立即吃瓜
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#index"
                onClick={(e) => handleScroll(e, '#index')}
                className="w-full sm:w-auto px-8 py-3.5 border border-background-300/40 hover:border-background-200 text-background-50 font-medium rounded-lg text-sm transition-all cursor-pointer whitespace-nowrap text-center"
              >
                浏览专题合集
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[280px] sm:w-[340px] sm:h-[340px] md:w-[400px] md:h-[400px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20stage%20scene%20with%20crimson%20velvet%20curtains%20and%20spotlight%2C%20mysterious%20silhouette%20on%20stage%2C%20theatrical%20drama%20atmosphere%2C%20dark%20elegant%20aesthetic%20with%20gold%20accents%2C%20entertainment%20show%20vibe%2C%20editorial%20quality%20photography%20with%20deep%20contrast&width=800&height=800&seq=hero-main-2026&orientation=squarish"
                alt="每日大赛黑料 - 大赛吃瓜主视觉"
                className="w-full h-full object-cover rounded-2xl"
                onError={(e) => {
                  (e.target as HTMLElement).parentElement!.style.display = 'none';
                }}
              />
              <div className="absolute inset-0 rounded-2xl border border-background-300/20"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}